import React from 'react';
import { Link } from "react-router-dom";
import TaxCalculator from './TaxCalculator';
import IconRow from './IconRow';
import './App.css';
//import logo from './assets/logo.png';


const HomePage = () => {
  return (
    <div className="App">
      <header className="App-header">
        <h4 className='ueberschrift'>Der Steuerrechner für Kryptowährungen</h4>
      </header>
      <main>
        <IconRow />
        <TaxCalculator />
      </main>
      <footer className="App-footer">
        <h className="Hafti">Haftungsausschluss: Diese Anwendung dient nur zu Informationszwecken. Die Berechnungen sind unverbindlich und ersetzen keine professionelle Steuerberatung.</h>
        <p className="Link"><Link to="/impressum"> Impressum & Datenschutz </Link></p>
        {/*
        <h className="Link"><Link to="/grundlagen"> Grundlagen </Link></h>
        */}
      </footer>
    </div>
  );
};

export default HomePage;